import React, { useEffect, useState } from 'react';

const SmartCountUp = ({ value, duration = 2000 }) => {
  const [display, setDisplay] = useState('0');

  useEffect(() => {
    // Extract number part
    const match = value.match(/[\d,.]+/);
    if (!match) {
      setDisplay(value);
      return;
    }

    const number = parseFloat(match[0].replace(/,/g, ''));
    const prefix = value.slice(0, match.index);
    const suffix = value.slice(match.index + match[0].length);
    let start = 0;
    const increment = number / (duration / 16);
    let frame;

    const update = () => {
      start += increment;
      if (start < number) {
        setDisplay(`${prefix}${Math.floor(start).toLocaleString()}${suffix}`);
        frame = requestAnimationFrame(update);
      } else {
        setDisplay(value);
        cancelAnimationFrame(frame);
      }
    };

    frame = requestAnimationFrame(update);

    return () => cancelAnimationFrame(frame);
  }, [value, duration]);

  return <span>{display}</span>;
};

export default SmartCountUp;
